import {
  Breakpoints,
  Carousel,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import { type Scalars } from '../../../__generated-gql-types__/globalTypes';
import BookedCoachCard from '../BookedCoachCard';

import {
  type BookedCoachesCarouselCoachFragment,
  useBookedCoachesCarouselGetBookedCoachesQuery,
} from './__generated-gql-types__/BookedCoachesCarousel.generated';

interface BookedCoachesCarouselProps {
  categoryUrn: Scalars['CategoryUrn']['output'];
  onClick?: (coach: BookedCoachesCarouselCoachFragment, index: number) => void;
}

const BookedCoachesCarousel: FC<BookedCoachesCarouselProps> = ({
  categoryUrn,
  onClick,
}) => {
  const isLg = useMediaQuery(Breakpoints.LG);
  const isMd = useMediaQuery(Breakpoints.MD);

  const { data: bookedCoachesData } =
    useBookedCoachesCarouselGetBookedCoachesQuery();
  const bookedCoaches = bookedCoachesData?.bookedCoaches.results;

  return bookedCoaches && bookedCoaches.length > 0 ? (
    <Carousel
      swiperProps={{
        slidesPerGroupAuto: false,
        slidesPerView: isLg ? 4 : isMd ? 3 : 1.15,
        spaceBetween: 20,
      }}
      title="Jump back in"
      items={bookedCoaches.map((bookedCoach, index) => (
        <BookedCoachCard
          key={bookedCoach.id}
          bookedCoach={bookedCoach}
          categoryUrn={categoryUrn}
          onClick={onClick ? () => onClick(bookedCoach, index) : undefined}
        />
      ))}
    />
  ) : (
    <></>
  );
};

export default BookedCoachesCarousel;
